<div class="loadData">
    <app-table
        [model]="dataExternalModel"
        [removeCard]="false"
        (paginatorEvent)="paginatorEvent($event)"
        (pageSizeEvent)="pageSizeEvent($event)"
        (searchEvent)="searchEvent($event)"
        (getRecords)="getTotal($event)"
        [hideIndex]="true"
        [hideExport]="true"
    ></app-table>

    <div class="buttonActions">
        <button (click)="handlingCancel()">Cancelar</button>
        <button (click)="handlingSave()">Guardar</button>
    </div>

</div>
